import { ExamDistributionActions } from '@exam-center/exam-distribution';
import {
  ExamDistributionFilterSection,
  MonthlyExamDistributionTable,
  ExamDistributionSummaryStatuses,
  ManuallyEditQSetModalProvider,
} from '@exam-center/exam-distribution-list';
import { Flex, PaperSection } from '@shared/components';

export default function ExamAssigningPage() {
  return (
    <ManuallyEditQSetModalProvider>
      <Flex sx={(theme) => ({ flexDirection: 'column', p: theme.spacing(6) })}>
        <PaperSection title='มอบหมายชุดข้อสอบ' endAdornment={<ExamDistributionActions />}>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              p: theme.spacing(6),
              gap: theme.spacing(4),
            })}
          >
            <ExamDistributionSummaryStatuses />
            <ExamDistributionFilterSection />
            <MonthlyExamDistributionTable />
          </Flex>
        </PaperSection>
      </Flex>
    </ManuallyEditQSetModalProvider>
  );
}
